import { Component, OnInit,ViewChild } from '@angular/core';
import { SearchProductparam } from 'src/app/Models/search-product';
import { TransactionService } from 'src/app/Services/transaction.service';

@Component({
  selector: 'app-product-price-upload',
  templateUrl: './product-price-upload.component.html',
  styleUrls: ['./product-price-upload.component.css']
})
export class ProductPriceUploadComponent implements OnInit {
  @ViewChild('file') myfileVariable:any;
  selectedPPFileName:string;
  showSpinner:boolean=false;
  Enable:boolean = false;

  constructor(private _TransactionService: TransactionService) {
    this.selectedPPFileName = "Choose file";
   }

  ngOnInit(): void {
  }
  searchProduct(searchProductparam:SearchProductparam){
    this.showSpinner=true;
    this._TransactionService.GetProductPriceExcelDocument(searchProductparam).subscribe((d: any) => {
         this.downloadFile((d))
         this.showSpinner = false;       
      });

  }


  downloadFile(data: any) {
   
    const blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8' });
    const url= window.URL.createObjectURL(blob);
    window.open(url);
 }
 

  changePP(event:any){
    if(event){
      if(event.target.files.length >0){
        this.selectedPPFileName = event.target.files[0].name;
      }
    }
}
uploadFile(files:any) {
   
  if (files.length === 0){
    alert('Please choose a file to upload!')
    return;
  }
     
  
  const formData = new FormData();

   let fileToUpload = <File>files[0];
   var filetype=fileToUpload.type;
    
    if(filetype!='application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') {
      alert('Please Upload .xlsx or .xls file');
      this.myfileVariable.nativeElement.value = "";
      this.selectedPPFileName = "";
      this.selectedPPFileName = "Choose file";
      return;
    }
    formData.append('file', fileToUpload, fileToUpload.name);
    this.showSpinner = true; 
    this.Enable =true;
    this._TransactionService.ImportProductPriceExcelDocument(formData).subscribe((event: any) => {
 
    var dataView = new DataView(event);
    var decoder = new TextDecoder('utf8');
    var decodedString = decoder.decode(dataView);
    this.showSpinner = false; 
    this.Enable =false
    if(decodedString=="1"){
     alert('uploaded successfully!!');
   }
   else{
    this.downloadFile(event);
    alert('uploaded successfully!!');
   }
   this.selectedPPFileName = "";
   this.selectedPPFileName = "Choose file";
    this.myfileVariable.nativeElement.value = "";
   });
    
}

}
